import React                    from 'react';

const Popover = props => {

    return <div className="IPRSPopover">
        <div className="IPRSPopoverContent">
            {props.children}
        </div>
    </div>
};

export default Popover;